/* eslint-disable max-lines-per-function */
import { Modal } from "@bluframe/blublocks"
import ActionsAndInfoSideBar from "components/ActionsAndInfoSideBar"
import ConfirmModal from "components/ConfirmModal"
import {
  FieldLabel,
  FieldLabelAndValue,
  FieldValue
} from "components/Fields/styled"
import { Form, Main, Top } from "components/List/ItemView/styled"

import { ComponentProps } from "."
import BioRow from "./BioRow"
import ImagesRow from "./ImagesRow"
import NameAndSlugRow from "./NameAndSlugRow"
import UrlAndDomainRow from "./UrlAndDomainRow"

const Item = ({
  actionButtonLabel,
  actionButtonOnClick,
  bioRef,
  domainRef,
  isActionButtonLoading,
  isAdd,
  isAdmin,
  isEditMode,
  isEditor,
  isModalOpen,
  item,
  logoImageIdRef,
  modalContent,
  nameRef,
  onGenerateSlug,
  onModalClose,
  onModalConfirmOpen,
  onModalDeleteConfirm,
  onModalPublishToggleConfirm,
  onSubmit,
  outlinedButtonLabel,
  outlinedButtonOnClick,
  slugRef,
  splashImageIdRef,
  urlRef
}: ComponentProps) => (
  <Form onSubmit={onSubmit}>
    <Top>
      <Main>
        {item?.id ? (
          <FieldLabelAndValue>
            <FieldLabel>{"ID"}</FieldLabel>

            <FieldValue>{item.id}</FieldValue>
          </FieldLabelAndValue>
        ) : null}

        <NameAndSlugRow
          isEditMode={isEditMode}
          item={item}
          nameRef={nameRef}
          onGenerateSlug={onGenerateSlug}
          slugRef={slugRef}
        />

        <UrlAndDomainRow
          domainRef={domainRef}
          isEditMode={isEditMode}
          item={item}
          urlRef={urlRef}
        />

        <ImagesRow
          isEditMode={isEditMode}
          item={item}
          logoImageIdRef={logoImageIdRef}
          splashImageIdRef={splashImageIdRef}
        />

        <BioRow bioRef={bioRef} isEditMode={isEditMode} item={item} />
      </Main>

      <ActionsAndInfoSideBar
        actionButtonLabel={actionButtonLabel}
        actionButtonOnClick={actionButtonOnClick}
        isActionButtonLoading={isActionButtonLoading}
        isAdd={isAdd}
        isAdmin={isAdmin}
        isEditMode={isEditMode}
        isEditor={isEditor}
        item={
          item
            ? {
                createdAt: item.createdAt,
                isPublished: item.isPublished,
                linkedItem: undefined,
                publishedAt: item.publishedAt,
                updatedAt: item.updatedAt
              }
            : undefined
        }
        onModalConfirmOpen={onModalConfirmOpen}
        outlinedButtonLabel={outlinedButtonLabel}
        outlinedButtonOnClick={outlinedButtonOnClick}
      />
    </Top>

    <Modal isOpen={isModalOpen} onClose={onModalClose}>
      {modalContent === "deleteConfirm" && (
        <ConfirmModal
          message={`Are you sure you want to delete?`}
          onClose={onModalClose}
          onConfirm={onModalDeleteConfirm}
        />
      )}

      {modalContent === "publishConfirm" && (
        <ConfirmModal
          message={`Are you sure you want to ${
            item?.isPublished ? "unpublish" : "publish"
          }?`}
          onClose={onModalClose}
          onConfirm={onModalPublishToggleConfirm}
        />
      )}
    </Modal>
  </Form>
)

export default Item
